import React, { useEffect, useState } from 'react';
import { Container, Table, Row, Col } from "reactstrap";
import '../../../css/loading.css'
import 'primeicons/primeicons.css';
import '../../../css/stats.css'
import '../../../custom.css'
import { Message } from 'primereact/message';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Button } from 'primereact/button';
import { useConstant } from '../../../ConstantContext';
import { fillAnalysis } from '../AnalysisFive';
import Strengths from '../Strengths'
import Weaknasses from '../Weaknesses';
import { useOptions } from '../StatsOptionsProvider';
import ARGindividual from './Tables/ARGindividual';
import OTTindividual from './Tables/OTTindividual';
import APPindividual from './Tables/APPindividual';
import { SelectButton } from 'primereact/selectbutton';
import PUTTindividual from './Tables/PUTTindividual';
import PinPosIndividual from './Tables/PinPosIndividual';

const IndividualStats = ({ data, baseline, requestProcessed, units }) => {

    const [scoreAverage, setScoreAverage] = useState("");
    const [totalImprovement, setTotalImprovement] = useState("");
    const [newScoreAverage, setNewScoreAverage] = useState("");

    const constants = useConstant();
    const options = useOptions();

    // Define the ranges for the values and attempts


    const tiger5stats = [{ name: 'bogeyPar5', display: 'Bogeys on Par 5' },
    { name: 'double', display: "Doubles+" }, { name: 'threePutt', display: "Three Putts" },
    { name: 'bogey150', display: `Bogeys inside ${units === "yards" ? baseline === "LPGA" ? '125y' : '150y' : baseline === "LPGA" ? '114m' : '137m'}` },
    { name: 'easyChip', display: 'Easy u&d' }];
    const optionsTiger = ['PerRound', 'Attempts', 'Count'];

    const clubsApp = ['lw', 'sw', 'gw', 'pw', '_9i', '_8i', '_7i', '_6i', '_5i', '_4i', '_3i', '_2i', '_4h', '_3h', '_7w', '_5w', '_3w'];

    const scoringStats = [{ name: 'scoreAvg', display: "Score Avg." }, { name: 'par3Avg', display: 'Par 3 Score Avg.' },
    { name: 'par4Avg', display: 'Par 4 Score Avg.' }, { name: 'par5Avg', display: 'Par 5 Score Avg.' },
    { name: 'birdiesPerRound', display: 'Birdies Per Round' }, { name: 'bogeysPerRound', display: 'Bogeys Per Round' },
    { name: 'doublesPerRound', display: 'Double Bogeys Per Round' }, { name: 'otherPerRound', display: 'Other Per Round' },];


    const goingForIt = [{ name: 'goingForIt', display: 'Going for the green' }, { name: 'goingGreenHit', display: 'Going for the green- Green Hit' },
    { name: 'goingBirdie', display: 'Going for the green - Birdie or better' }, { name: 'goingBogey', display: 'Going for the green - Bogey or worse' }];
    const goingForItOptions = ['Pct', 'Count', 'Attempts'];
    const goingAvg = [{ name: 'avgGoing', display: 'Going for it average score' }, { name: 'avgLayUp', display: 'Laying up average' }]


    const mistakes = [{ name: 'good', display: "Good shots" }, { name: 'technique', display: "Technique error" },
    { name: 'mental', display: "Mental error" }, { name: 'decision', display: "Decision error" }];
    const mistakesOptions = ['Tee', 'App', 'Arg', 'Putting'];
    const [isAdvanced, setIsAdvanced] = useState(false);
    const [statsType, setStatsType] = useState("Basic");
    const statsTypes = ["Basic", "Advanced"];
    // Function to format the ranges for display
    const formatDisplayRange = (range) => {
        if (range.length >= 8) {
            const start = range.slice(2, 5);
            const end = range.slice(5);
            return `${baseline === "yards" ? start : parseInt(start * constants.yardsToMeters)}-${baseline === "yards" ? end : parseInt(end * constants.yardsToMeters)}${baseline === "yards" ? "y" : "m"}`;
        } else if (range.length === 7) {
            const start = range.slice(2, 4);
            const end = range.slice(4);
            return `${baseline === "yards" ? start : parseInt(start * constants.yardsToMeters)}-${baseline === "yards" ? end : parseInt(end * constants.yardsToMeters)}${baseline === "yards" ? "y" : "m"}`;
        } else {
            const start = range.slice(2, 5);
            return `${baseline === "yards" ? start : parseInt(start * constants.yardsToMeters)}+${baseline === "yards" ? "y" : "m"}`;
        }
    };
    // Create state variables and setters using loops
    const [state, setState] = useState(() => {
        const initialState = {};
        initialState['noOfRounds'] = 0;
        tiger5stats.forEach((stat) => {
            optionsTiger.forEach((option) => {
                initialState[`${stat.name}${option}`] = 0;
            });
        });
        clubsApp.forEach((clubApp) => {
            initialState[`${clubApp}`] = {};
        });
        initialState[`sgOTT`] = 0.0;
        initialState[`sgOTTdriver`] = 0.0;
        initialState[`sgOTTother`] = 0.0;
        options.teeStats.forEach((stat) => {
            initialState[`${stat}Attempts`] = 0;
            initialState[`${stat}Count`] = 0;
            initialState[`${stat}Hit`] = 0;

        });
        options.teeMiss.forEach((stat) => {
            initialState[`${stat.name}`] = 0;
        });
        options.clubsTee.forEach((clubTee) => {
            initialState[`tee${clubTee}Attempts`] = 0;
            initialState[`tee${clubTee}Success`] = 0;
            initialState[`fairway${clubTee}Hit`] = 0;
        });
        scoringStats.forEach((stat) => {
            initialState[`${stat.name}`] = 0;
        });
        options.sgApp.forEach((stat) => {
            initialState[`${stat}`] = 0.0;
        });
        options.sgAppAdvanced.forEach((stat) => {
            initialState[`${stat}`] = 0.0;
        });
        initialState[`sgAPP`] = 0.0;
        options.rangesApp.forEach((range) => {
            options.positionsApp.forEach((position) => {
                initialState[`${range.name}${position}`] = 0;
            });
        });
        options.gfApp.forEach((range) => {
            options.gfOptions.forEach((position) => {
                initialState[`${range}${position}`] = 0;
            });
        });
        options.missApp.forEach((stat) => {
            initialState[`${stat.name}`] = 0;
        });
        options.expected.forEach((stat) => {
            initialState[`${stat.name}`] = 0;
        });
        goingForIt.forEach((a) => {
            goingForItOptions.forEach((b) => {
                initialState[`${a}${b}`] = 0;
            });
        });
        initialState['goingDistanceAfter'] = 0;
        options.sgPuttAdvanced.forEach((stat) => {
            initialState[`${stat.name}`] = 0.0;
        })
        options.puttingFeet.forEach((stat) => {
            initialState[`${stat.name}`] = 0;
        });
        options.argStats.forEach((a) => {
            options.argOptions.forEach((b) => {
                initialState[`${b}${a}`] = 0;
            });
        });
        options.argSG.forEach((a) => {
            initialState[`${a}`] = 0;
        });
        mistakes.forEach((a) => {
            mistakesOptions.forEach((b) => {
                initialState[`${b}${a}`] = 0;
            });
        });
        goingAvg.forEach((a) => {
            initialState[`${a.name}`] = 0.0
        })
        options.rangesPins.forEach((a) => {
            options.positions.forEach((b) => {
                initialState[`${a.name}.${b.name}StrokesGainedAttempts`] = 0
                initialState[`${a.name}.${b.name}StrokesGainedPerShot`] = 0.0

            })

        })
        return initialState;
    });

    const [activeTabs, setActiveTabs] = useState([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11])

    useEffect(() => {
        options.setUnits(units);
    }, [units])

    useEffect(() => {
        if (data || requestProcessed) {
            fillOutTable(data);
        }
        if (baseline === "LPGA") {
            constants.setPgaBase(false);
        }
        if (units === "meters") {
            constants.setUnits("meters");
        }
    }, [data, requestProcessed, units])
    /**
     * Calls all functions that fill out tables
     * @param {JSON} data 
     */
    async function fillOutTable(data) {
        try {
            fillAnalysis(data, units, setState, setScoreAverage, setTotalImprovement, setNewScoreAverage, [], 5, 5, isAdvanced);
            fillStats(data);
            setActiveTabs([0, 1, 2, 3, 4, 5, 8, 9, 10, 11])
        } catch (e) {
            console.error(e)
        }
    }
    function fillStats(data) {
        /*    var tables = ["advapproachtable", "tiger5table", "clubstable",
               "teetable", "scoringtable", "approachtable", "goingtable",
               "puttingtable", "argtable", "analysistable", "strengthtable"]
           tables.forEach((name) => {
               removeLoadingAnimation(name);
           })
           console.log("here") */
        Object.keys(data).forEach((key) => {
            setState((prev) => ({
                ...prev,
                [key]: data[key],
            }));
        });
    }
    /**
     * Renders table for tiger 5 stats with a option to change row colors based on 
     * cell values
     * @returns Table
     */
    function renderTiger5() {
        return (
            <div className="table-responsive">
                <Table id='tiger5table' className='stats-table'>
                    <thead>
                        <tr>
                            <th></th>
                            <th>Per round</th>
                            <th>Count</th>
                            <th>Attempts</th>
                            <th>Tour average</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tiger5stats.map((stat) => (
                            <tr key={`${stat.name}`}
                                style={{
                                    color: (state[`${stat.name}Attempts`] > 0 || stat.name === "double") &&
                                        (constants.tourAvg[`${stat.name}PerRound`].low ?
                                            (state[`${stat.name}PerRound`] < constants.tourAvg[`${stat.name}PerRound`].greenValue ||
                                                state[`${stat.name}PerRound`] > constants.tourAvg[`${stat.name}PerRound`].redValue) && 'white' :
                                            (state[`${stat.name}PerRound`] > constants.tourAvg[`${stat.name}PerRound`].greenValue ||
                                                state[`${stat.name}PerRound`] < constants.tourAvg[`${stat.name}PerRound`].redValue) && 'white'),

                                    backgroundColor: (state[`${stat.name}Attempts`] > 0 || stat.name === "double") &&
                                        (constants.tourAvg[`${stat.name}PerRound`].low === true ?
                                            (state[`${stat.name}PerRound`] < constants.tourAvg[`${stat.name}PerRound`].greenValue ? constants.green :
                                                state[`${stat.name}PerRound`] > constants.tourAvg[`${stat.name}PerRound`].redValue ? constants.red : '')
                                            :
                                            (state[`${stat.name}PerRound`] > constants.tourAvg[`${stat.name}PerRound`].greenValue ? constants.green :
                                                state[`${stat.name}PerRound`] < constants.tourAvg[`${stat.name}PerRound`].redValue ? constants.red : ''))
                                }}>
                                <td>{`${stat.display}`}</td>
                                <td className={`${data === null && 'loading-cell '} data-cell`}>{state[`${stat.name}PerRound`]}{stat.name === "easyChip" && "%"}</td>
                                <td>{state[`${stat.name}Count`]}</td>
                                <td>{stat.name === "double" ? "--" : state[`${stat.name}Attempts`]}</td>
                                <td>{constants.tourAvg[`${stat.name}PerRound`]?.value}</td>
                            </tr>

                        ))}
                    </tbody>

                </Table>
            </div>
        )
    }
    /**
     * Renders table for scoring stats with a option to change row colors based on 
     * cell values
     * @returns Table
     */
    function renderScoring() {
        return (
            <div className="table-responsive">
                <Table id='scoringtable' className='stats-table'>
                    <thead>
                        <tr>
                            <th></th>
                            <th>Value</th>
                            <th>Tour average</th>
                        </tr>
                    </thead>
                    <tbody>
                        {scoringStats.map((stat) => (
                            <tr key={`${stat.name}`}
                                style={{
                                    color:
                                        (constants.tourAvg[`${stat.name}`].low ?
                                            (state[`${stat.name}`] < constants.tourAvg[`${stat.name}`].greenValue ||
                                                state[`${stat.name}`] > constants.tourAvg[`${stat.name}`].redValue) && 'white' :
                                            (state[`${stat.name}`] > constants.tourAvg[`${stat.name}`].greenValue ||
                                                state[`${stat.name}`] < constants.tourAvg[`${stat.name}`].redValue) && 'white'),

                                    backgroundColor:
                                        (constants.tourAvg[`${stat.name}`].low ?
                                            (state[`${stat.name}`] < constants.tourAvg[`${stat.name}`].greenValue ? constants.green :
                                                state[`${stat.name}`] > constants.tourAvg[`${stat.name}`].redValue ? constants.red : '')
                                            :
                                            (state[`${stat.name}`] > constants.tourAvg[`${stat.name}`].greenValue ? constants.green :
                                                state[`${stat.name}`] < constants.tourAvg[`${stat.name}`].redValue ? constants.red : ''))
                                }}>
                                <td>{`${stat.display}`}</td>
                                <td className={`${data === null && 'loading-cell '} data-cell`}>{state[`${stat.name}`]}</td>
                                <td>{constants.tourAvg[`${stat.name}`]?.value}</td>
                            </tr>

                        ))}
                    </tbody>
                </Table>
            </div>
        )
    }
    /**
     * Renders table for going for it stats with a option to change row colors based on 
     * cell values
     * @returns Table
     */
    function renderGoing() {
        return (
            <div className="table-responsive">
                <Table id='goingtable' className='stats-table'>
                    <thead>
                        <tr>
                            <th></th>
                            <th>Value</th>
                            <th>Count</th>
                            <th>Attempts</th>
                            <th>Tour average</th>
                        </tr>
                    </thead>
                    <tbody>
                        {goingForIt.map((stat) => (
                            <tr key={`${stat.name}`}
                                style={{
                                    color: (state[`${stat.name}Attempts`] > 0 || stat.name === "double") &&
                                        (constants.tourAvg[`${stat.name}Pct`].low ?
                                            (state[`${stat.name}Pct`] < constants.tourAvg[`${stat.name}Pct`].greenValue ||
                                                state[`${stat.name}Pct`] > constants.tourAvg[`${stat.name}Pct`].redValue) && 'white' :
                                            (state[`${stat.name}Pct`] > constants.tourAvg[`${stat.name}Pct`].greenValue ||
                                                state[`${stat.name}Pct`] < constants.tourAvg[`${stat.name}Pct`].redValue) && 'white'),

                                    backgroundColor: (state[`${stat.name}Attempts`] > 0 || stat.name === "double") &&
                                        (constants.tourAvg[`${stat.name}Pct`].low === true ?
                                            (state[`${stat.name}Pct`] < constants.tourAvg[`${stat.name}Pct`].greenValue ? constants.green :
                                                state[`${stat.name}Pct`] > constants.tourAvg[`${stat.name}Pct`].redValue ? constants.red : '')
                                            :
                                            (state[`${stat.name}Pct`] > constants.tourAvg[`${stat.name}Pct`].greenValue ? constants.green :
                                                state[`${stat.name}Pct`] < constants.tourAvg[`${stat.name}Pct`].redValue ? constants.red : ''))
                                }}>
                                <td>{`${stat.display}`}</td>
                                <td className={`${data === null && 'loading-cell '} data-cell`}>{state[`${stat.name}Pct`]}%</td>
                                <td>{state[`${stat.name}Count`]}</td>
                                <td>{state[`${stat.name}Attempts`]}</td>
                                <td>{constants.tourAvg[`${stat.name}Pct`]?.value}</td>
                            </tr>
                        ))}
                        <tr key={`goingDistanceAfter`}
                            style={{
                                color: (state[`goingForItCount`] > 0) &&
                                    (state[`goingDistanceAfter`] < constants.tourAvg[`goingDistanceAfter`].greenValue ||
                                        state[`goingDistanceAfter`] > constants.tourAvg[`goingDistanceAfter`].redValue) && 'white',

                                backgroundColor: (state[`goingForItCount`] > 0) &&
                                    (state[`goingDistanceAfter`] < constants.tourAvg[`goingDistanceAfter`].greenValue ? constants.green :
                                        state[`goingDistanceAfter`] > constants.tourAvg[`goingDistanceAfter`].redValue ? constants.red : '')
                            }}>
                            <td>{`Average Distance after Going for it Shot`}</td>
                            <td className={`${data === null && 'loading-cell '} data-cell`}>{units === "yards" ? state[`goingDistanceAfter`] + " y" : (parseFloat(state[`goingDistanceAfter`]) * constants.yardsToMeters).toFixed(1) + " m"}</td>
                            <td>--</td>
                            <td>--</td>
                            <td>{constants.tourAvg[`goingDistanceAfter`]?.value}</td>
                        </tr>
                        {goingAvg.map((stat) => (
                            <tr key={`${stat.name}`}>
                                <td>{`${stat.display}`}</td>
                                <td className={`${data === null && 'loading-cell '} data-cell`}>{state[`${stat.name}`]}</td>
                                <td>--</td>
                                <td>--</td>
                                <td>--</td>
                            </tr>
                        ))}
                    </tbody>

                </Table>
            </div>
        )
    }
    const getClubStyle = (club) => {
        return {
            color: (state[`${club}`]?.strokesGainedShot < constants.sgPerShotLower || state[`${club}`]?.strokesGainedShot > constants.sgPerShotUpper) && 'white',
            backgroundColor:
                state[`${club}`]?.strokesGainedShot < constants.sgPerShotLower
                    ? constants.red
                    : state[`${club}`]?.strokesGainedShot > constants.sgPerShotUpper
                        ? constants.green
                        : '',
        };
    };
    /**
     * Renders table for clubs stats with a option to change row colors based on 
     * cell values
     * @returns Table
     */
    function renderClubs() {
        return (
            <div className="table-responsive">
                <Table id='clubstable' className='stats-table'>
                    <thead>
                        <tr>
                            <th></th>
                            <th>Value</th>
                            <th>Per Round</th>
                            <th>Attempts</th>
                            <th>Miss Left</th>
                            <th>Miss Right</th>
                            <th>Miss Long</th>
                            <th>Miss Short</th>
                        </tr>
                    </thead>
                    <tbody>
                        {clubsApp.map((club) => (
                            <tr style={{ display: state[`${club}`]?.attempts > 0 ? "" : "none", }}>
                                <td>{club.charAt(0) === "_" ? `${club.substring(1)}` : ` ${club.toUpperCase()}`}</td>
                                <td style={getClubStyle(club)} className={`${data === null && 'loading-cell '} data-cell`}>{state[`${club}`]?.strokesGainedShot}</td>
                                {(data && data.noOfRounds > 1) ? <td style={getClubStyle(club)}>{data && state[`${club}`]?.attempts !== 0 && parseFloat((state[`${club}`]?.strokesGainedShot / state[`${club}`]?.attempts) * (state[`${club}`]?.attempts / data.noOfRounds)).toFixed(3)}</td> : <td>--</td>}
                                <td>{state[`${club}`]?.attempts}</td>
                                <td style={{
                                    color: (state[`${club}`]?.missLeft > state[`${club}`]?.missRight) && 'white',
                                    backgroundColor: (state[`${club}`]?.missLeft > state[`${club}`]?.missRight) && constants.red
                                }}>{state[`${club}`]?.missLeft}%</td>
                                <td style={{
                                    color: (state[`${club}`]?.missLeft < state[`${club}`]?.missRight) && 'white',
                                    backgroundColor: (state[`${club}`]?.missLeft < state[`${club}`]?.missRight) && constants.red
                                }}>{state[`${club}`]?.missRight}%</td>
                                <td style={{
                                    color: (state[`${club}`]?.missLong > state[`${club}`]?.missShort) && 'white',
                                    backgroundColor: (state[`${club}`]?.missLong > state[`${club}`]?.missShort) && constants.red
                                }}>{state[`${club}`]?.missLong}%</td>
                                <td style={{
                                    color: (state[`${club}`]?.missLong < state[`${club}`]?.missShort) && 'white',
                                    backgroundColor: (state[`${club}`]?.missLong < state[`${club}`]?.missShort) && constants.red
                                }}>{state[`${club}`]?.missShort}%</td>
                            </tr>
                        ))}
                    </tbody>

                </Table>
            </div >
        )
    }
    /**
     * Renders table for mistakes stats with a option to change row colors based on 
     * cell values
     * @returns Table
     */
    function renderMistake() {
        return (
            <div className="mistake-container">
                {mistakesOptions.map((option) => (
                    <Table id={`mistaketable${option}`} className='mistake-table'>
                        <thead>
                            <tr>
                                <th>{option}</th>
                                <th>Value</th>
                            </tr>
                        </thead>
                        <tbody>{mistakes.map((mistake) => (
                            <tr>
                                <td>{mistake.display}</td>
                                <td className='data-cell'>{state[`${mistake.name}${option}`]}%</td>
                            </tr>
                        ))}
                        </tbody>
                    </Table>
                ))}
            </div>
        )
    }
    function openAll() {
        if (activeTabs.length > 0) {
            setActiveTabs([])
        } else {
            setActiveTabs([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17])
        }
    }
    function onAdvanced(value) {
        console.log(value);
        setStatsType(value);
        setIsAdvanced(value !== "Basic");
        fillAnalysis(data, units, setState, setScoreAverage, setTotalImprovement, setNewScoreAverage, [], 5, 5, value !== "Basic");
    }
    return (
        < div >
            <>
                <Container className="ps-0">
                    {baseline === "LPGA" &&
                        <Message className='m-3' severity="info" text="*LPGA average/baseline" />}
                    {data && <Message className='m-3' severity="info" text={`${data.noOfRounds} round${data.noOfRounds === 1 ? "" : "s"}`} />}
                    <Row className="mt-3 mb-5">
                        <Col>
                            <div style={{ display: "flex", flexWrap: "wrap", flexDirection: 'row', alignItems: 'flex-start', overflowX: 'hidden', justifyContent: 'left', gap: "30px" }}>
                                <Button label={activeTabs.length > 0 ? "Close All" : "Open All"}
                                    icon={activeTabs.length > 0 ? "pi pi-minus" : "pi pi-plus"}
                                    className="mb-4" onClick={() => openAll()} />
                                <SelectButton value={statsType} onChange={(e) => onAdvanced(e.value)} options={statsTypes} />
                            </div>
                            <Accordion activeIndex={activeTabs} multiple onTabChange={(e) => setActiveTabs(e.index)}>
                                <AccordionTab header="5 Strengths">
                                    <Strengths state={state} data={data} />
                                </AccordionTab>
                                <AccordionTab header="5 Elements to Improve">
                                    <Weaknasses state={state} data={data} scoreAverage={scoreAverage} totalImprovement={totalImprovement} newScoreAverage={newScoreAverage} />
                                </AccordionTab>
                                <AccordionTab header="Tiger 5">
                                    {renderTiger5()}
                                </AccordionTab>
                                <AccordionTab header="Scoring">
                                    {renderScoring()}
                                </AccordionTab>
                                <AccordionTab header="Off the Tee">
                                    <OTTindividual state={state} data={data} isAdvanced={isAdvanced} />
                                </AccordionTab>
                                <AccordionTab header="Approaches">
                                    <APPindividual state={state} data={data} isAdvanced={isAdvanced} />
                                </AccordionTab>
                                {isAdvanced && <AccordionTab header="Pin Positions">
                                    <PinPosIndividual state={state} data={data} />
                                </AccordionTab>}
                                {isAdvanced && <AccordionTab header="Clubs">
                                    {renderClubs()}
                                </AccordionTab>}
                                {isAdvanced && <AccordionTab header="Going for It">
                                    {renderGoing()}
                                </AccordionTab>}
                                <AccordionTab header="Around the Green">
                                    <ARGindividual state={state} data={data} isAdvanced={isAdvanced} />
                                </AccordionTab>
                                <AccordionTab header="Putting">
                                    <PUTTindividual state={state} data={data} isAdvanced={isAdvanced} />
                                </AccordionTab>
                                {isAdvanced && <AccordionTab header="Mistakes" >
                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }} >
                                        {renderMistake()}
                                    </div>
                                </AccordionTab >}
                            </Accordion>
                        </Col>
                    </Row>
                </Container>
            </>
        </div >
    );
}

export { IndividualStats }